<div class="bypass-block-link-wrapper">
  <a
    class="bypass-block-link skip-to-main-content"
    tabindex="1"
    (click)="focusOnElement('.router-outlet-container')"
    (keydown.enter)="focusOnElement('.router-outlet-container')">
    {{ 'wl.star.bypass_block.skip_to_main_content' | translate }}
  </a>
</div>
